import React from "react";
import ReactTooltip from "react-tooltip";

const PaidDownload = ({
  downloadPercentage,
  file,
  onCheckoutClick,
  checkout,
  payForVideoToolTip,
}) => {
  return (
    <>
      <div
        className={
          "share-item text-white hover-change " +
          ((downloadPercentage > 0 && downloadPercentage !== 100) ||
          (file.switches &&
            file.switches.downloadeble.selected === "disabled") ||
          file.downloadPrice === 0 ||
          typeof file.downloadPrice === "undefined" ||
          !file.downloadPrice ||
          checkout
            ? "d-none"
            : "")
        }
        onClick={onCheckoutClick}
        data-tip
        data-for="payForVideo"
      >
        {/* On hover popups download price */}
        <i className={"fas text-white fa-dollar-sign"}></i>
        <i>{file.downloadPrice ? "$" + file.downloadPrice.toFixed(2) : ""}</i>
      </div>
      <ReactTooltip id="payForVideo" type="dark" place="bottom" effect="solid">
        <span>{payForVideoToolTip}</span>
      </ReactTooltip>
    </>
  );
};
export default PaidDownload;
